export default __webpack_public_path__ + "static/media/blog-post.2.97d2d56c.md";